import { render, staticRenderFns } from "./Curtain.vue?vue&type=template&id=aeab08c8&scoped=true&"
import script from "./Curtain.vue?vue&type=script&lang=js&"
export * from "./Curtain.vue?vue&type=script&lang=js&"
import style0 from "./Curtain.vue?vue&type=style&index=0&id=aeab08c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aeab08c8",
  null
  
)

export default component.exports